// Généré par maquettes/outils/dc2react.py à partir de maquettes/autopilot.js.
// Pilote automatique des démos : un faux curseur se déplace, clique sur les vrais
// éléments de l'interface ([data-demo="..."]) et zoome dessus, avec GSAP.
// Une scène = un élément [data-demo-stage] contenant un [data-demo-zoom].
// Le scénario joué dépend de [data-demo-script]. Dès que le visiteur touche
// la scène, le pilote rend la main ; un bouton [data-demo-restart] la lui reprend.
import gsap from 'gsap';

export let startAutopilot;
{

  const SCRIPTS = {
    stock: [
      ['silentClick', 'reset-compare'], ['wait', 800],
      ['move', 'chart'], ['wait', 1200],
      ['move', 'compare'], ['click', 'compare'], ['wait', 700],
      ['move', 'izmir'], ['click', 'izmir'], ['wait', 2600], ['hide']
    ],
    finance: [
      ['silentClick', 'shown'], ['wait', 900],
      ['move', 'real'], ['click', 'real'], ['wait', 1800],
      ['move', 'ecart'], ['wait', 2000], ['hide']
    ],
    ventes: [
      ['silentClick', 'b-veste'], ['wait', 900],
      ['move', 'bubbles'], ['wait', 1000],
      ['move', 'b-gants'], ['click', 'b-gants'], ['wait', 2200], ['hide']
    ],
    ops: [
      ['silentClick', 'replay-prop'], ['wait', 900],
      ['move', 'grid'], ['wait', 1000],
      ['move', 'apply'], ['click', 'apply'], ['wait', 3200], ['hide']
    ]
  };

  const PEOPLE = {
    stock: ['Léa · Achats', '#2347D6'],
    finance: ['Sam · Finance', '#15171A'],
    ventes: ['Inès · Marketing', '#C2410C'],
    ops: ['Hugo · Opérations', '#0F766E']
  };

  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const DEBUG = /[?&]debug/.test(location.search);
  const log = (...a) => { if (DEBUG) { (window.__apLog = window.__apLog || []).push(Math.round(performance.now()) + ' ' + a.join(' ')); } };

  function makeCursor() {
    const c = document.createElement('div');
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:absolute;left:0;top:0;width:26px;height:26px;pointer-events:none;z-index:9999;opacity:0;will-change:transform';
    c.innerHTML =
      '<span class="ap-ring" style="position:absolute;left:-14px;top:-14px;width:28px;height:28px;border-radius:999px;border:2px solid #2347D6;opacity:0"></span>' +
      '<svg width="26" height="26" viewBox="0 0 26 26" style="position:absolute;left:-3px;top:-2px;filter:drop-shadow(0 3px 6px rgba(21,23,26,.35))"><path class="ap-arrow" d="M4 2 L4 20 L9 15.5 L12.5 23 L15.8 21.5 L12.4 14.2 L19 14.2 Z" fill="#15171A" stroke="#FFFFFF" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
      '<span class="ap-label" style="position:absolute;left:20px;top:22px;padding:4px 9px;border-radius:999px;background:#15171A;color:#fff;font:700 12px/1.2 Archivo,sans-serif;white-space:nowrap;box-shadow:0 6px 14px -6px rgba(21,23,26,.5)"></span>';
    document.body.appendChild(c);
    return c;
  }

  class Stage {
    constructor(el) {
      this.el = el;
      this.run = 0;
      this.user = false;
      this.visible = false;
      this.cursor = makeCursor();
      this.cursorShown = false;
      this.done = {};
      el.addEventListener('pointerdown', (e) => {
        if (!e.isTrusted) return;
        const restart = e.target.closest && e.target.closest('[data-demo-restart]');
        if (restart) {
          this.user = false;
          setTimeout(() => this.start(true), 400);
          return;
        }
        this.user = true;
        log('le visiteur prend la main');
        this.stop();
      }, true);
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries.some((x) => x.isIntersecting);
        log('visible', this.script(), this.visible);
        if (this.visible) this.start(false);
      }, { threshold: 0.45 });
      this.io.observe(el);
      this.mo = new MutationObserver(() => {
        if (this.script() !== this.current) {
          this.stop();
          setTimeout(() => this.start(false), 500);
        }
      });
      this.mo.observe(el, { attributes: true, attributeFilter: ['data-demo-script'] });
    }
    destroy() {
      this.run++;
      this.user = true;
      this.io.disconnect();
      this.mo.disconnect();
      gsap.killTweensOf(this.cursor);
      this.cursor.remove();
    }
    script() { return this.el.getAttribute('data-demo-script'); }
    zoomEl() { return this.el.querySelector('[data-demo-zoom]'); }
    target(name) { return this.el.querySelector('[data-demo="' + name + '"]'); }
    stop() {
      this.run++;
      this.current = null;
      gsap.killTweensOf(this.cursor);
      gsap.to(this.cursor, { opacity: 0, duration: 0.25 });
      this.cursorShown = false;
      const z = this.zoomEl();
      if (z) { gsap.killTweensOf(z); gsap.to(z, { x: 0, y: 0, scale: 1, duration: 0.5, ease: 'power2.out' }); }
    }
    start(force) {
      if (reduced || this.user || !this.visible) return;
      const name = this.script();
      if (!SCRIPTS[name]) return;
      if (!force && name !== 'hero' && this.done[name]) return;
      if (this.current === name) return;
      this.current = name;
      const who = PEOPLE[name];
      if (who) {
        this.cursor.querySelector('.ap-label').textContent = who[0];
        this.cursor.querySelector('.ap-label').style.background = who[1];
        this.cursor.querySelector('.ap-arrow').setAttribute('fill', who[1]);
      }
      const id = ++this.run;
      this.play(SCRIPTS[name], id, name).catch(() => {});
    }
    alive(id) { return id === this.run && !this.user; }
    async waitVisible(id) {
      while (this.alive(id) && (!this.visible || document.hidden)) await sleep(300);
    }
    point(t) {
      const r = t.getBoundingClientRect();
      return { x: r.left + window.scrollX + Math.min(r.width * 0.5, 120), y: r.top + window.scrollY + r.height * 0.55 };
    }
    async move(t) {
      const p = this.point(t);
      if (!this.cursorShown) {
        if (!this.placed) {
          const s = this.el.getBoundingClientRect();
          gsap.set(this.cursor, { x: s.right + window.scrollX - 40, y: s.bottom + window.scrollY - 30 });
          this.placed = true;
        }
        gsap.to(this.cursor, { opacity: 1, duration: 0.3 });
        this.cursorShown = true;
      }
      const cx = gsap.getProperty(this.cursor, 'x'), cy = gsap.getProperty(this.cursor, 'y');
      const d = Math.hypot(p.x - cx, p.y - cy);
      await gsap.to(this.cursor, { x: p.x, y: p.y, duration: Math.min(1.1, 0.45 + d / 900), ease: 'power2.inOut' });
    }
    async click(t) {
      const ring = this.cursor.querySelector('.ap-ring');
      gsap.fromTo(ring, { scale: 0.4, opacity: 0.9 }, { scale: 1.6, opacity: 0, duration: 0.5, ease: 'power2.out' });
      await gsap.to(this.cursor, { scale: 0.82, duration: 0.09, yoyo: true, repeat: 1 });
      t.click();
    }
    async zoom(t, s) {
      const z = this.zoomEl();
      if (!z) return;
      const cur = gsap.getProperty(z, 'scale') || 1;
      const zr = z.getBoundingClientRect(), tr = t.getBoundingClientRect();
      const W = z.offsetWidth, H = Math.min(z.offsetHeight, this.el.clientHeight);
      const px = (tr.left + tr.width / 2 - zr.left) / cur, py = (tr.top + tr.height / 2 - zr.top) / cur;
      const x = Math.min(0, Math.max(W - s * W, W / 2 - s * px));
      const y = Math.min(0, Math.max(H - s * z.offsetHeight, H / 2 - s * py));
      gsap.to(this.cursor, { opacity: 0, duration: 0.2 });
      this.cursorShown = false;
      await gsap.to(z, { x: x, y: y, scale: s, transformOrigin: '0 0', duration: 0.9, ease: 'power3.inOut' });
    }
    async zoomOut() {
      const z = this.zoomEl();
      if (z) await gsap.to(z, { x: 0, y: 0, scale: 1, duration: 0.7, ease: 'power3.inOut' });
    }
    async play(steps, id, name) {
      for (let i = 0; i < steps.length; i++) {
        await this.waitVisible(id);
        if (!this.alive(id)) return;
        const [op, a, b] = steps[i];
        log(name, id, op, a || '', 'cible:', a ? !!this.target(a) : '-');
        const t = a ? this.target(a) : null;
        if (op === 'wait') await sleep(a);
        else if (op === 'silentClick') { if (t) { t.click(); await sleep(60); } }
        else if (op === 'move') { if (t) await this.move(t); }
        else if (op === 'click') { if (t) await this.click(t); }
        else if (op === 'zoom') { if (t) await this.zoom(t, b); }
        else if (op === 'zoomOut') await this.zoomOut();
        else if (op === 'hide') { gsap.to(this.cursor, { opacity: 0, duration: 0.3 }); this.cursorShown = false; }
        else if (op === 'loop') { i = -1; }
      }
      if (this.alive(id)) { this.done[name] = true; this.current = null; }
    }
  }

  // Lance le pilote sur toutes les scènes de la page ; renvoie la fonction qui l'arrête.
  startAutopilot = function () {
    const stages = new Map();
    const scan = () => document.querySelectorAll('[data-demo-stage]').forEach((el) => {
      if (!stages.has(el)) stages.set(el, new Stage(el));
    });
    scan();
    const watch = new MutationObserver(scan);
    watch.observe(document.body, { childList: true, subtree: true });
    return () => { watch.disconnect(); stages.forEach((st) => st.destroy()); stages.clear(); };
  };
}
